import { useAuth0 } from '@auth0/auth0-react';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';

import { getEventsContaining } from '@/apis/events';
import { domainCodeAtom } from '@australiangreens/ag-internal-components';
import { createChipLabelText, createChipTooltip } from '@/util';
import { labelSorting } from '@/util/labelSorting';

export const useLookupEvents = () => {
  const { getAccessTokenSilently } = useAuth0();
  const domainCode = useAtomValue(domainCodeAtom);

  return useCallback(
    async (lookupValue: string) => {
      const token = await getAccessTokenSilently();

      return (await getEventsContaining(token, lookupValue, domainCode))
        .map((x) => {
          const { id, title, startDate = '' } = x;
          const chipTooltipText = createChipTooltip(title, startDate);
          const chipLabel = createChipLabelText(title, startDate);
          return {
            id: id,
            label: chipTooltipText,
            chipLabel: chipLabel,
            tooltipContent: chipTooltipText,
          };
        })
        .sort(labelSorting);
    },
    [domainCode, getAccessTokenSilently]
  );
};
